import { InboxIcon } from '@heroicons/react/24/outline';
import { Panel } from '../../../../components/panels/Panel';
import { ProgressBar } from '../../../../components/progressbar/ProgressBar';

const SCORE_COLORS = {
  good: '#22c55e',
  medium: '#f59e0b',
  bad: '#ef4444',
};

const getScoreStatus = (value, mediumThreshold, goodThreshold) => {
  if (value >= goodThreshold) {
    return {
      label: 'Bon',
      color: SCORE_COLORS.good,
    };
  }

  if (value >= mediumThreshold) {
    return {
      label: 'Moyen',
      color: SCORE_COLORS.medium,
    };
  }

  return {
    label: 'Mauvais',
    color: SCORE_COLORS.bad,
  };
};

export const VACAeroDashboardKpi = ({ label, value, subtitle = null }) => {
  return (
    <Panel noHeader rounded category="secondary" overflowAuto={false} className="h-full">
      <div className="flex h-full flex-col gap-3">
        <div className="text-sm font-semibold uppercase text-perception-gray-500">
          {label}
        </div>

        <div className="text-3xl font-semibold text-perception-gray-300">
          {value}
        </div>

        {subtitle && (
          <div className="mt-auto text-xs text-perception-gray-600">
            {subtitle}
          </div>
        )}
      </div>
    </Panel>
  );
};

export const VACAeroDashboardScoreKpi = ({
                                           label,
                                           value,
                                           displayValue,
                                           mediumThreshold,
                                           goodThreshold,
                                           subtitle = null,
                                         }) => {
  const hasValue = Number.isFinite(value);
  const status = hasValue ? getScoreStatus(value, mediumThreshold, goodThreshold) : null;

  return (
    <Panel noHeader rounded category="secondary" overflowAuto={false} className="h-full">
      <div className="flex h-full flex-col gap-3">
        <div className="flex items-start justify-between gap-3">
          <div className="text-sm font-semibold uppercase text-perception-gray-500">
            {label}
          </div>

          {status && (
            <div className="text-xs font-medium" style={{ color: status.color }}>
              {status.label}
            </div>
          )}
        </div>

        <div className="text-3xl font-semibold text-perception-gray-300">
          {displayValue}
        </div>

        {hasValue && (
          <ProgressBar
            value={value}
            size="small"
            color={status.color}
            bgColor="bg-perception-black-800"
          />
        )}

        {subtitle && (
          <div className="mt-auto text-xs text-perception-gray-600">
            {subtitle}
          </div>
        )}
      </div>
    </Panel>
  );
};

export const VACAeroDashboardNoData = ({ text = 'Aucune donnée' }) => {
  return (
    <div className="flex min-h-40 flex-col items-center justify-center gap-3 text-perception-gray-700">
      <InboxIcon className="size-12" />

      <div className="text-sm">
        {text}
      </div>
    </div>
  );
};

export const VACAeroDashboardNoDataNotice = () => {
  return (
    <div className="rounded-md border border-perception-black-500 bg-perception-black-700 px-4 py-3 text-sm text-perception-gray-500">
      Aucune donnée disponible sur cette période
    </div>
  );
};